<div class="modal-header">
  <h4 class="modal-title pull-left">Error</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  An error occurred processing your request.
</div>

